import React from 'react';
import Opt_Classwise_Sub from './Opt_Classwise_Sub';
import '../../../CommonCSS/SocietyCSS.css'

const Opt_Classwise_SubApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Optional Classwise Subject</h5>
          </div>  
        </div>
        <Opt_Classwise_Sub/>
      </div>
    </div >
  );
};

export default Opt_Classwise_SubApp;
